import Vue from 'vue'
import App from './App.vue'
import router from '@/routers'
import store from '@/stores'
import register from '@/utils/register'

Vue.config.productionTip = false;

Vue.use(register);

const vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

window['Vue'] = vue;